export const EXTERNAL_DOCS_LINKS = {
  PLATFORM:
    "https://support.titanhq.com/en/69450-welcome-to-the-titanhq-platform-.html",
  EMAIL_SECURITY:
    "https://support.titanhq.com/en/index-en.html?contextId=Dashboard-EmailSec-Learn-More",
  ARC_TITAN:
    "https://support.titanhq.com/en/index-en.html?contextId=Dashboard-EmailArc-Learn-More",
  PHISHING_SIMULATION:
    "https://support.titanhq.com/en/index-en.html?contextId=Dashboard-PhishSim-Learn-More",
  SECURITY_AWARENESS_TRAINING:
    "https://www.titanhq.com/security-awareness-training-ui",
  REMOVING_ES_SOLUTION:
    "https://support.titanhq.com/en/index-en.html?contextId=remove-es-solution",
  DELETING_CUSTOMER:
    "https://support.titanhq.com/en/index-en.html?contextId=delete-customer",
  OUTLOOK_ADD_IN_DEPLOY_INSTRUCTIONS:
    "https://support.titanhq.com/en/index-en.html?contextId=connection-outlook-learn-more",
  ES_OVERVIEW:
    "https://support.titanhq.com/en/index-en.html?contextId=MSP-Dashboard-EmailSec-Overview-Learn-More",
  ES_INCIDENTS:
    "https://support.titanhq.com/en/index-en.html?contextId=incidents-msp-learn-more",
  ES_MAIL_FLOW:
    "https://support.titanhq.com/en/index-en.html?contextId=mail-flow-msp-learn-more",
  ES_LINK_LOCK:
    "https://support.titanhq.com/en/index-en.html?contextId=link-lock-msp-learn-more",
  ES_NOTIFICATIONS:
    "https://support.titanhq.com/en/index-en.html?contextId=ES-notifications",
  ES_SUMMARY_REPORT:
    "https://support.titanhq.com/en/index-en.html?contextId=summary-report-msp-learn-more",
  ES_INSIGHTS:
    "https://support.titanhq.com/en/index-en.html?contextId=insights-msp-learn-more",
  MSP_CUSTOMERS_OVERVIEW:
    "https://support.titanhq.com/en/index-en.html?contextId=Customers-Learn-More",
  MSP_LICENCE_USAGE_OVERVIEW:
    "https://support.titanhq.com/en/index-en.html?contextId=MSP-License-Usage-Learn-More",
  CUSTOMER_CONNECTIONS_LEARN_MORE:
    "https://support.titanhq.com/en/index-en.html?contextId=Connections-Learn-More",
  ADMINISTRATORS_TABLE:
    "https://support.titanhq.com/en/index-en.html?contextId=administrators",
  PLATFORM_RELEASE_BLOG:
    "https://support.titanhq.com/en/69455-platform-release-blog.html",
  CUSTOMER_ADMINISTRATORS_TABLE:
    "https://support.titanhq.com/en/index-en.html?contextId=customer-admin",
  MSP_BRANDING_LEARN_MORE:
    "https://support.titanhq.com/en/index-en.html?contextId=branding-learn-more",
};
